<template>
  <b-modal
    ref="modal"
    title="Guia CID, CIAP e SIGTAP"
    size="xl"
    hide-footer
    body-class="modal-guia-codigos__body"
  >
    <iframe
      class="modal-guia-codigos__iframe"
      :src="url"
      title="Guia CID, CIAP e SIGTAP"
    ></iframe>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalCodigosClinicos',
  data() {
    return {
      buscas: [],
    }
  },
  computed: {
    url() {
      const url = 'https://esusfeedback.com.br/guia-codigos-indicadores'

      if (!this.buscas.length) {
        return url
      }

      const query = this.buscas
        .map((busca) => `busca=${encodeURIComponent(busca)}`)
        .join('&')

      return `${url}?${query}`
    },
  },
  methods: {
    /**
     * Abre o modal com o guia de códigos dos indicadores.
     *
     * @param {array} buscas
     * @returns {void}
     */
    open(buscas = []) {
      this.buscas = buscas

      this.$nextTick(() => {
        this.$refs.modal.show()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-guia-codigos {
  &__iframe {
    display: block;
    width: 100%;
    height: 75vh;
    border: 0;
  }
}

::v-deep .modal-guia-codigos__body {
  padding: 0;
}
</style>
